import { Subject } from 'rxjs'
import { RxJS } from './RxJS'
import { RxJSStateDefinable } from '../Types/Types'

const userInfoErrorSubject: Subject<Definable<boolean>> = new Subject<Definable<boolean>>()

RxJS.userInfoError = RxJS.userInfoError ?? {
    subject: userInfoErrorSubject,
    observable: userInfoErrorSubject.asObservable(),
    announce: (isError?: boolean): void => {
        userInfoErrorSubject.next(isError)
    }
}

export const userInfoErrorState$: RxJSStateDefinable<boolean> = RxJS.userInfoError
